import React, { createContext, useContext, useState } from 'react';

// Context'i oluştur
const CategoryContext = createContext();

// Provider bileşeni
export const CategoryProvider = ({ children }) => {
  const [categoryInfo, setCategoryInfo] = useState('');

  return (
    <CategoryContext.Provider value={{ categoryInfo, setCategoryInfo }}>
      {children}
    </CategoryContext.Provider>
  );
};

// Custom hook
export const useCategoryContext = () => {
  return useContext(CategoryContext);
};
